import classNames from "classnames";

import { Button } from "@jti/core-components/components/Button";

import { trackCtaClick } from "../../utils/trackCtaClick";

import styles from "./AccountActionButtons.module.scss";

export type AccountActionButtonsType = {
  signInTitle: string;
  signInUrl: string;
  registerUrl?: string;
  registerTitle?: string;
  trackingEvent?: string;
  className?: string;
  position?: "start" | "center" | "end";
  theme?: "light" | "dark";
};

export const AccountActionButtons = ({
  signInUrl,
  signInTitle,
  registerUrl,
  registerTitle,
  trackingEvent,
  position,
  theme,
  className,
}: AccountActionButtonsType) => {
  const dispatchGTMLoginEvent = () => {
    trackCtaClick(trackingEvent, "LoyaltyAccountActionButtonsLogin");
  };

  return (
    <div
      className={classNames(styles.accountActionButtons, className, {
        [styles.start]: position === "start",
        [styles.end]: position === "end",
        ["light-theme"]: theme === "light",
        ["dark-theme"]: theme === "dark",
      })}
      data-testid="accountActionButtons"
    >
      <Button href={signInUrl} size="md" data-testid="accountActionButtonsSignIn" onClick={dispatchGTMLoginEvent}>
        {signInTitle}
      </Button>
      {registerTitle && registerUrl && (
        <Button
          size="md"
          href={registerUrl}
          variant="secondary"
          data-testid="accountActionButtonsRegister"
          onClick={() => trackCtaClick(registerTitle, "LoyaltyAccountActionButtonsRegister")}
        >
          {registerTitle}
        </Button>
      )}
    </div>
  );
};
